/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import React from 'react'
import { BaseModal } from 'components/Modals/BaseModal'
import * as classes from './styles'

export const confirmationModalClasses = {
  title: 'confirmation-modal-title',
  subtitle: 'confirmation-modal-subtitle',
}

export type ConfirmationModalProps = {
  open: boolean
  title: string
  subtitle: string | React.ReactElement
  onClose: () => void
  onConfirm: () => void
  closeText?: string
  confirmText?: string
  isBlueConfirm?: boolean
  isLoading?: boolean
  className?: string
}

export const ConfirmationModal = ({
  open,
  title,
  subtitle,
  onConfirm,
  onClose,
  confirmText = 'Confirm',
  closeText = 'Not Now',
  isBlueConfirm,
  isLoading,
  ...props
}: ConfirmationModalProps) => (
  <BaseModal open={open} onClose={onClose} {...props}>
    <Typography css={classes.title} className={confirmationModalClasses.title} variant="title2">
      {title}
    </Typography>
    <Typography css={classes.subtitle} className={confirmationModalClasses.subtitle} variant="body2">
      {subtitle}
    </Typography>
    <Button
      variant="contained"
      color={isBlueConfirm ? 'blue' : 'red'}
      fullWidth
      size="large"
      onClick={onConfirm}
      disabled={isLoading}
      data-testid="modal-confirm-button"
    >
      {confirmText}
    </Button>
    <Button
      variant="outlined"
      color="blue"
      fullWidth
      size="large"
      onClick={onClose}
      disabled={isLoading}
      data-testid="modal-close-button"
    >
      {closeText}
    </Button>
  </BaseModal>
)
